import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/Breadcrumbs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/SmartAppBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/TripChat.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserAuthProvider"] */ "/app/app/contexts/ReviewerAuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TripChatContextProvider"] */ "/app/app/contexts/TripChatContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@ant-design/nextjs-registry/es/AntdRegistry.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/app/styles/colors.css");
